import * as Flags from 'country-flag-icons/react/3x2';
import { cn } from '@/lib/utils';

interface CountryFlagProps {
  iso2?: string | null;
  className?: string;
  /** Rendered when iso2 is empty or has no matching flag. */
  fallback?: React.ReactNode;
}

export function CountryFlag({ iso2, className, fallback = null }: CountryFlagProps) {
  const Flag = iso2 ? Flags[iso2.toUpperCase() as keyof typeof Flags] : undefined;
  if (!Flag) return fallback;
  return <Flag className={cn('inline-block w-5 shrink-0 rounded-[2px]', className)} />;
}
